import React from 'react'
// import { Flex, Heading, IconButton, VStack, Spacer,Button  } from '@chakra-ui/react';
// import { useColorMode } from "@chakra-ui/color-mode";
import {FaSun, FaMoon, FaCog} from 'react-icons/fa'
import { Link } from 'react-router-dom';


function Nav() {

    return (
        <div>   
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
            
              <Link className="nav-brand" to="/">Project X</Link>  


              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                {/* <ul className="navbar-nav mr-auto">
                  <li className="nav-item active">
                  <Link className="nav-link" to="/">Home</Link>    
                  </li>
                  <li className="nav-item">
                  <Link className="nav-link"  to="/about">About</Link>    
                  </li>
                  <li className="nav-item">
                  <Link className="nav-link" to="/share">Share</Link>    
                  </li>
                  
                  <li className="nav-item">
                  <Link className="nav-link"  to="/submit">Submit a Website</Link> 
                  </li>
                </ul> */}
                <div className="circle-animation">

                 <div className="circle circle-4" ></div>
            <div className="circle circle-3" ></div>
            <div className="circle circle-2" ></div>
            <div className="circle circle-1" ></div>
                </div>
                <p><Link className="nav-link" to="/tips-n-tricks">Tips & Tricks</Link> </p>
              </div>
            </nav>
             
        </div>
    )
}

export default Nav
